var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    viewBox: "0 0 500 820",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "map-marker-38-f",
    x2: 1,
    gradientTransform: "matrix(2.3002e-15 -37.566 37.566 2.3002e-15 416.46 541)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126fc6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4c9cd1",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "map-marker-38-s",
    x2: 1,
    gradientTransform: "matrix(1.1667e-15 -19.053 19.053 1.1667e-15 414.48 522.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2e6c97",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3883b7",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter957",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(70,200,0)",
    result: "flood1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    k2: 1,
    operator: "in",
    result: "composite2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.542 0 0 19.542 -7889.1 -9807.4)",
    filter: "url(#filter957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m416.54 503.61c-6.573 0-12.044 5.691-12.044 11.866 0 2.778 1.564 6.308 2.694 8.746l9.306 17.872 9.262-17.872c1.13-2.438 2.738-5.791 2.738-8.746 0-6.175-5.383-11.866-11.956-11.866zm0 7.155c2.584 0.017 4.679 2.122 4.679 4.71s-2.095 4.663-4.679 4.679c-2.584-0.017-4.679-2.09-4.679-4.679 0-2.588 2.095-4.693 4.679-4.71z",
    fill: "url(#map-marker-38-f)",
    stroke: "url(#map-marker-38-s)",
    strokeWidth: "1.1px"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m239.69 345.36c-33.535-4.9031-61.077-31.199-67.425-64.372-5.1755-27.05 3.906-54.464 24.373-73.573 16.272-15.193 32.497-21.663 54.324-21.663 15.921 0 27.574 3.1603 41.267 11.192 7.1099 4.17 22.916 19.977 27.086 27.086 8.2021 13.985 11.202 25.289 11.207 42.232 5e-3 15.089-1.8021 23.024-8.0888 35.528-15.313 30.455-49.461 48.437-82.744 43.571z",
    fill: "#fff",
    strokeWidth: 8.1491,
    style: {
      paintOrder: "fill markers stroke"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMarker);
export default __webpack_public_path__ + "static/media/greenMarker.fdbc43cf1b901da1d13345c9a22617bb.svg";
export { ForwardRef as ReactComponent };